import { useContext, useState } from "react";
import { Calendar, Badge, Button, Popover, Col, Row, Flex } from "antd";
import "../TimeSlots/timeslots.css";
import dayjs from "dayjs";
import { DATE_FORMAT, startSeason } from "$utils";
import { AuthContext } from "$context/AuthContextProvider";
import { Navigate } from "react-router";
import { useQuery } from "@tanstack/react-query";
import { fetchAppointsAsExcel, fetchTimeSlotsQuery } from "$api/client";
import SelectLocation from "../TimeSlots/SelectLocation/SelectLocation";
import { Typography } from "antd";
import UpdateBooking from "../TimeSlots/UpdateBooking";
import BlockTimeSlot from "../BlockTimeSlot/BlockTimeSlot";

const { Text } = Typography;

const CarLocationComponent = () => {
  const [selectedLocation, setSelectedLocation] = useState({
    locationId: null,
    dealerCode: "",
    deliveryTime: null,
  });
  const [date, setDate] = useState(
    dayjs().isBefore(startSeason) ? startSeason : dayjs()
  );

  const authContext = useContext(AuthContext);

  const { data: locationTimeSlots } = useQuery({
    queryKey: ["timeSlots", selectedLocation.locationId],
    queryFn: fetchTimeSlotsQuery,
    enabled: selectedLocation.locationId !== "",
  });

  const dataCellRender = (current) => {
    if (locationTimeSlots) {
      const date_str = current.format("YYYY-MM-DD");
      let item = locationTimeSlots[date_str];
      if (item) {
        item = item.sort((a, b) => dayjs(a.date) - dayjs(b.date));
        const items = item.map((value, index) => {
          if (value.booked === false) {
            let badge = <Badge status="success" />;
            const blockButtion = (
              <BlockTimeSlot
                key={`${value.date}~BlockButton`}
                locationId={selectedLocation.locationId}
                locationSlot={value}
              />
            );
            return (
              <div key={index}>
                <Text level={5} style={{ marginBottom: "-25px" }}>
                  {badge} {blockButtion}
                </Text>
              </div>
            );
          } else {
            let badge = <Badge status="error" />;
            let button = (
              <UpdateBooking
                key={selectedLocation.locationId}
                timeSlots={locationTimeSlots}
                locationSlot={value}
              />
            );
            return (
              <div key={value.id}>
                <Text level={5} style={{ marginBottom: "-25px" }}>
                  {badge}
                  {button}
                </Text>
              </div>
            );
          }
        });

        return <>{items}</>;
      }
    }
    return null;
  };
  if (authContext.isAuthenticated === false || authContext.isAdmin === true) {
    return <Navigate to="/login" />;
  }

  return (
    <div className="layout-card">
      <div className="slot_card">
        <Row>
          <Col span={8}>
            <SelectLocation
              selectedItem={selectedLocation}
              handleChange={setSelectedLocation}
            />
          </Col>
          <Col span={8} offset={8} style={{ paddingBottom: "10px" }}>
            <Flex align={"flex-end"} justify="flex-end" gap="middle">
              <Popover
                title="Termine exportieren"
                content={
                  <div>
                    Erhalten Sie eine xlsx-Datei mit den Terminen der nächsten 3
                    Arbeitstage. Sie können das Startdatum festlegen, wenn Sie
                    auf dem Kalendar ein Datum auswählen.
                  </div>
                }
              >
                <Button
                  type="primary"
                  onClick={() => fetchAppointsAsExcel(date.format(DATE_FORMAT))}
                  disabled={!selectedLocation}
                >
                  Termine exportieren
                </Button>
              </Popover>
            </Flex>
          </Col>
        </Row>
        <div className="calendar_card">
          <Calendar
            key={selectedLocation}
            cellRender={dataCellRender}
            onChange={setDate}
          />
        </div>
      </div>
    </div>
  );
};

export default CarLocationComponent;
